import { FC, memo } from "react";
import { Product } from "~/common/props/orchestrator";
import { useTranslation } from "react-i18next";
import RecommendedProducts from "~/modules/ads-suggestions/components/recommended-products";
import { EVENTS } from "~/constants/events";
import ProductCard from "@components-monorepo/components/product-card/product-card-ssr";
import { ProductsGrid } from "@components-monorepo/components/products-grid";
import WidgetContainer from "@components-monorepo/components/widget-container";
import {
  AppLink,
  makeUrl,
  useAppLocation,
  WidgetCaller,
  WidgetProps } from
"@commons-monorepo/index";
import {
  useAnalytics,
  useAppNavigate,
  useAppSearchParams,
  ProductsGridConfig } from
"@commons-monorepo/index";
import { ProductFilter } from "~/components/product-filter/product-filter";
import styles from "./CatalogueMainProducts.module.css";
import { useLoaderData, useLocation, useOutletContext } from "@remix-run/react";
import Pagination from "~/components/pagination/pagination";
import { UiButton } from "@ui-monorepo/index";

const CatalogueMainProducts: FC<WidgetProps<Product[], ProductsGridConfig>> = ({
  id,
  data,
  config,
  theme,
  localConfig,
  caller,
  withoutPaddingX
}) => {
  const { isMobile, storeMetadata, url: partnerUrl } = useOutletContext<any>();
  const { paginatedData } = useLoaderData();
  const { t } = useTranslation();
  const navigate = useAppNavigate();
  const { search } = useLocation();
  const [logEvent] = useAnalytics({ storeMetadata });
  const [searchParams] = useAppSearchParams();
  const { pathname } = useAppLocation();
  const hideFilterButton = !pathname?.includes("todos-los-productos");

  const handleShowFilters = () => {
    logEvent(EVENTS.SELECT_FILTER_ORDER);
    navigate(`filtros${search}`, { preventScrollReset: true, replace: false });
  };

  const numberPage = Number(searchParams.get("page")) || 1;

  const goBack = () => {
    window.history.state?.usr?.prevPath ?
    navigate(-1) :
    navigate(`/catalogo/${partnerUrl}`);
  };
  const highlightBackground = config?.highlight_background;

  const allProductsLog = () => {
    logEvent("select_button", {
      event_subtype: "show_all_products",
      user_type: "buyer",
      platform: "web"
    });
  };

  return (
    <WidgetContainer
      className={styles.widgetContainer}
      containerClassName={styles.widgetContainerContent}
      highlight={!!highlightBackground}
      withoutPaddingX={withoutPaddingX}>

      <div
        className={`${styles.wrapperCatalogueMainProducts} catalogue-main-products`}
        id={id}
        role='products-grid'>

        <div id='products-filter' className={styles.filterContainer}>
          <div className={styles.productFilter}>
            <ProductFilter
              onClick={!hideFilterButton ? handleShowFilters : undefined}
              productsQuantity={paginatedData.total} />

          </div>
        </div>

        <ProductsGrid className={styles.grid} theme={theme}>
          {data?.map((product) =>
          <ProductCard
            key={`catalogue-main-products-product-${product.id}`}
            product={product}
            theme={theme}
            addProduct={localConfig?.cart.addProduct}
            removeProduct={localConfig?.cart.removeProduct}
            manuallyChangeProduct={localConfig?.cart.manuallyChangeProduct}
            cartProducts={localConfig?.cart.cartProducts}
            locale={storeMetadata?.locale}
            currency={storeMetadata?.currency}
            storeMetadata={storeMetadata} />

          )}
        </ProductsGrid>
        <RecommendedProducts className={styles.recommendedProducts} />
        {caller &&
        [
        WidgetCaller.CatalogueAllProducts,
        WidgetCaller.CatalogueInternal].
        includes(caller) ?
        <Pagination
          page={numberPage}
          pages={paginatedData.totalPages}
          isMobile={isMobile} /> :


        <AppLink
          onClick={allProductsLog}
          className={styles.allProductsButton}
          to={makeUrl(pathname, "todos-los-productos")}>

            <UiButton isSecondary theme={theme}>
              {t("productsGrid.see_all")}
            </UiButton>
          </AppLink>}

      </div>
    </WidgetContainer>);

};

export default memo(CatalogueMainProducts);